define('entities/setting',[
  'app',
  'backbone',
  'settings',
  'jquery',
  'underscore'
], function(
  App,
  Backbone,
  Settings,
  $,
  _
) {
  'use strict';

  var Setting = Backbone.Model.extend({
    fetch: function() {
      this.url = Settings.url('compuzz', 'v2/settings/' + this.get('secId'));

      return Backbone.Model.prototype.fetch.call(this);
    },
    defaults: {
      code: '',
      sGroup: '',
      description: '',
      params: ''
    },
    idAttribute: 'secId',
    getImageUid:function() {},

    postUrl: function () {
      return Settings.url('compuzz', 'v2/settings');
    },

    save: function() {
      this.url = this.postUrl();
      return Backbone.Model.prototype.save.call(this);
    }
  });

  var SettingCollection = Backbone.Collection.extend({
    url: function() {
      return Settings.url('compuzz', 'v2/settings');
    },
    model: Setting
  });

  var API = {

    getSettingCollectionUrl: function() {
      new SettingCollection();
      var params = {};
      return Settings.url('compuzz', 'v2/settings', params);
    },

    getSettingCollectionUrlKitp: function(kitpSecId) {
        new SettingCollection();
        var params = {};
        return Settings.url('compuzz', 'v2/kitps/'+ kitpSecId + '/settings', params);
    },

    getAllSetting: function(params) {
      var url = Settings.url('compuzz', 'v2/settings', params),
          defer = $.Deferred();

      $.ajax({
        method: 'get',
        url: url,
        success: function(items) {
          var list = [];
          _.each(items, function(item){
            list.push(item.secId);
          });
          defer.resolve(list);
        }
      });

      return defer.promise();
    },

    getSettingCountUrl: function() {
      var params = '';
      return 'v2/settings/rowCount' + params;
    },

    getSettingCountUrlKitp: function(kitpSecId) {
        var params = '';
        return 'v2/kitps/'+ kitpSecId + '/settings/rowCount' + params;
    },

    deleteSetting: function(secId){
      var url = Settings.url('compuzz', 'v2/settings/'+secId),
          defer = $.Deferred();

      $.ajax({
        type: 'DELETE',
        url: url,
        success: function (data) {
          defer.resolve(data);
        }
      });

      return defer.promise();
    }
  };

  App.reqres.setHandler('setting:get-collection-url', function() {
      return API.getSettingCollectionUrl();
  });

  App.reqres.setHandler('setting:get-collection-url-kitp', function(kitpSecId) {
      return API.getSettingCollectionUrlKitp(kitpSecId);
  });

  App.reqres.setHandler('setting:get-collection-to-page', function(params) {
      return API.getAllSetting(params);
  });

  App.reqres.setHandler('setting:get-count-url', function() {
    return API.getSettingCountUrl();
  });

  App.reqres.setHandler('setting:get-count-url-kitp', function(kitpSecId) {
      return API.getSettingCountUrlKitp(kitpSecId);
  });

  App.reqres.setHandler('setting:model', function(itemJSON) {
    return new Setting(itemJSON);
  });

  App.reqres.setHandler('setting:delete', function(secId) {
    return API.deleteSetting(secId);
  });
});
